import axios, { AxiosRequestConfig } from 'axios';
import configuration from '../envConfig';
const HTTP_REQUEST_TIMEOUT = 30000;

const defaultConfig: AxiosRequestConfig = {
  baseURL: configuration.urlApi,
  validateStatus: (status) => status === 200,
  timeout: HTTP_REQUEST_TIMEOUT,
};

function request(config: AxiosRequestConfig) {
  const req = axios({ ...defaultConfig, ...config });
  return req;
}

const httpMethods = {
  get(url: string, config: AxiosRequestConfig) {
    return request({ ...config, method: 'get', url });
  },

  post(url: string, data: any = {}, config: AxiosRequestConfig = {}) {
    return request({ ...config, method: 'post', url, data });
  },

  patch(url: string, data: any, config: AxiosRequestConfig = {}) {
    return request({ ...config, method: 'patch', url, data });
  },

  put(url: string, data: any, config: AxiosRequestConfig = {}) {
    return request({ ...config, method: 'put', url, data });
  },

  delete(url: string, config: AxiosRequestConfig) {
    return request({ ...config, method: 'delete', url });
  },
};

export default httpMethods;
